import { Col, Divider, Row, theme } from 'antd';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import BarChart from '../../../../components/DashboardPage/BarChart';
import InfoBox from '../../../../components/DashboardPage/InfoBox';
import { generateReportQueryStringFromQuery } from './TicketReportFiltersContainer';

const TicketReportItemsContainer = () => {
    const {
        token: { marginMD }
    } = theme.useToken();

    const { query } = useRouter();
    const { t } = useTranslation('reports');
    const queryString = generateReportQueryStringFromQuery(query);
    return (
        <>
            <Row style={{ justifyContent: 'space-evenly' }} gutter={[marginMD / 2, marginMD / 2]}>
                <InfoBox
                    url={queryString ? `/reports/tickets/total-ticket-count?${queryString}` : null}
                    title={t('ticketReports.reportItems.totalTicketCount')}
                />
                <InfoBox
                    url={queryString ? `/reports/tickets/new-tickets?${queryString}` : null}
                    title={t('ticketReports.reportItems.newTickets')}
                />
                <InfoBox
                    url={queryString ? `/reports/tickets/open-tickets?${queryString}` : null}
                    title={t('ticketReports.reportItems.opentickets')}
                />
                <InfoBox
                    url={queryString ? `/reports/tickets/pending-tickets?${queryString}` : null}
                    title={t('ticketReports.reportItems.pendingTickets')}
                />
                <InfoBox
                    url={queryString ? `/reports/tickets/on-hold-tickets?${queryString}` : null}
                    title={t('ticketReports.reportItems.onHoldTickets')}
                />
                <InfoBox
                    url={queryString ? `/reports/tickets/solved-tickets?${queryString}` : null}
                    title={t('ticketReports.reportItems.solvedTickets')}
                />
                <InfoBox
                    url={queryString ? `/reports/tickets/closed-tickets?${queryString}` : null}
                    title={t('ticketReports.reportItems.closedTickets')}
                />
                <InfoBox
                    url={queryString ? `/reports/tickets/average-solve-time?${queryString}` : null}
                    title={t('ticketReports.reportItems.averageSolvingDuration')}
                />
                <InfoBox
                    url={queryString ? `/reports/tickets/average-first-response-time?${queryString}` : null}
                    title={t('ticketReports.reportItems.averageFirstResponseTime')}
                />
                {/* <InfoBox
                    url={ queryString ?`/reports/tickets/reopened-tickets?${queryString}`: null}
                    title={t('ticketReports.reportItems.reOpenedTickets')}
                /> */}
            </Row>
            <Divider />
            <Row style={{ justifyContent: 'space-evenly' }}>
                {/* <Col span={10}>
                    <PieChart
                        url={ queryString ?`/reports/tickets/number-of-survey-responses?${queryString}`: null}
                        title={t('ticketReports.reportItems.numberOfSurveyResponses')}
                    />
                </Col> */}
                <Col span={20}>
                    <BarChart
                        url={queryString ? `/reports/tickets/ticket-count-per-hour?${queryString}` : null}
                        title={t('ticketReports.reportItems.numberOfTicketsPerHour')}
                    />
                </Col>
            </Row>
            <Divider />
            {/* <Row style={{ justifyContent: 'space-evenly' }} gutter={[marginMD / 2, marginMD / 2]}> */}
            {/* <InfoBox
                    url={ queryString ?`/reports/tickets/number-of-tickets-solved-at-initial-contact?${queryString}`}
                    title={t('ticketReports.reportItems.numberOfTicketsSolvedAtInitialContact')}
                /> */}
            {/* <InfoBox
                    url={queryString ? `/reports/tickets/average-solve-time?${queryString}` : null}
                    title={t('ticketReports.reportItems.averageSolvingDuration')}
                /> */}
            {/* <InfoBox
                    url={ queryString ?`/reports/tickets/first-response-time-via-email?${queryString}`: null}
                    title={t('ticketReports.reportItems.firstResponseTimeViaEmail')}
                />
                <InfoBox
                    url={ queryString ?`/reports/tickets/initial-contact-resolution-time?${queryString}`: null}
                    title={t('ticketReports.reportItems.initialContactResolutionTime')}
                />
                <InfoBox
                    url={ queryString ?`/reports/tickets/average-resolution-score?${queryString}`: null}
                    title={t('ticketReports.reportItems.averageResolutionScore')}
                /> */}
            {/* </Row> */}
            {/* <Divider /> */}
        </>
    );
};

export default TicketReportItemsContainer;
